import { isApple } from "./is-apple"

/**
 * The chord that submits from inside an editor — Mod-Enter, where plain Enter belongs to the
 * document. Shared by every editor that sits in something with a submit button (a comment
 * dialog, a note in a menu), so they all answer to the same keys.
 */
export function isSubmitShortcut(event: KeyboardEvent): boolean {
  if (event.key !== "Enter" || event.shiftKey || event.altKey) return false
  return isApple ? event.metaKey && !event.ctrlKey : event.ctrlKey && !event.metaKey
}
